import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function HeaderModal({
  title,
  displayModal,
  setDisplayModal,
  children,
}: {
  title: string;
  displayModal: boolean;
  setDisplayModal: (displayModal: boolean) => void;
  children: React.ReactNode;
}) {
  return (
    <>
      <Dialog
        open={displayModal}
        as="div"
        className="relative z-50 focus:outline-none"
        onClose={() => setDisplayModal(false)}
      >
        <div className="fixed inset-0 bg-black/50 " aria-hidden="true" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center">
            <DialogPanel className="w-screen h-screen max-w-screen overflow-y-auto bg-surface-base p-3 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
              <div className="flex flex-row items-center mb-3 gap-5">
                <div className={title === "Navigation" ? "order-2" : ""}>
                  <DialogTitle
                    as="h2"
                    className="font-bold text-text-primary text-2xl"
                  >
                    {title}
                  </DialogTitle>
                </div>
                <div
                  className={`${
                    title === "Navigation" ? "order-1" : "ml-auto"
                  }`}
                >
                  <button
                    className={`rounded-xl bg-surface-raised p-[0.675rem] shadow-sm hover:shadow-md hover:bg-surface-base`}
                    aria-label="Close modal"
                    onClick={() => setDisplayModal(false)}
                  >
                    <XMarkIcon className="w-6 h-6 text-text-base" />
                  </button>
                </div>
              </div>
              <div className="mt-5">{children}</div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}
